<div class="card" *ngIf="equipment">
  <div class="card-header" style="height: auto">
    <!-- Title -->
    <lib-terminal-header
      [equipment]="equipment"
      [link]="'/farming/' + equipment.serialNumber + '/climate'"
      [showStatusIcon]="true"
      [connected]="equipmentConnected()"
    ></lib-terminal-header>
  </div>

  <div *ngIf="meteoRows.length > 1" class="row mx-0 mx-lg-2 my-3">
    <div *ngFor="let meteo of meteoPills()" class="col-6 col-lg-3 mb-3">
      <app-info-pill
        [type]="'CLIMATE'"
        [value]="meteo.value"
        [height]="'56px'"
        [magnitudeLabel]="'climate_meteo_grid_' + meteo.key | translation"
        [magnitudeUnit]="meteo.unit"
        [magnitudeTooltip]="undefined"
        [virtual]="meteo.origin === 'VIRTUAL'"
        [icon]="meteo.key"
        [hideIconOnMobile]="false"
      >
      </app-info-pill>
    </div>
  </div>
</div>

<div class="card" *ngIf="!equipment && terminal">
  <div class="card-header" style="height: auto">
    <!-- Title -->
    <lib-terminal-header
      [equipment]="terminal"
      [link]="'/farming/' + terminal.vid + '/climate'"
      [showStatusIcon]="true"
      [connected]="
        terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED ? 2 : 0
      "
    ></lib-terminal-header>
  </div>
  <div
    class="row my-4 mx-2"
    *ngIf="terminal.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED"
  >
    <i>{{ 'no_results' | translation }}</i>
  </div>
  <div
    class="row mx-2"
    *ngIf="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED"
  >
    <app-terminal-placeholder-data [terminalType]="'climate'" [size]="'small'">
    </app-terminal-placeholder-data>
  </div>
</div>
